import React, { useEffect, useState, useCallback, useRef } from 'react';
import CommonModal from './CommonModal';
import { callAPI } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';
import { toast } from 'react-toastify';

const LinklyRefundStatusModal = ({ isOpen, uuid, amount, onClose, onRefundComplete }) => {
  const [display, setDisplay] = useState({ DL1: '', DL2: '' });
  const [done, setDone] = useState(false);
  const [failed, setFailed] = useState(false);
  const uiLocked = useRef(false);

  const fetchStatus = useCallback(async () => {
    if (!uuid) return;
    try {
      const res = await callAPI(`${apiUrls.LINKLY_STATUS}?uuid=${uuid}`, {}, 'GET');
      const data = res?.data || {};
      const eft = data.eftpos_display || {};

      setDisplay({
        DL1: eft.displayLine1 || 'Processing refund...',
        DL2: eft.displayLine2 || '',
      });

      const status = data.linkly_payment?.status;

      if (status == 1 || status === 'success') {
        uiLocked.current = true;
        setDone(true);
        setFailed(false);
        toast.success('Refund completed successfully');
        setTimeout(() => {
          if (onRefundComplete) onRefundComplete();
          onClose();
        }, 1500);
      } else if (status == 2 || status === 'failed') {
        uiLocked.current = true;
        setFailed(true);
        setDone(false);
      }
    } catch {
      setDisplay({ DL1: 'Checking refund status...', DL2: '' });
    }
  }, [uuid, onClose, onRefundComplete]);

  useEffect(() => {
    if (!isOpen || !uuid) return;

    uiLocked.current = false;
    setDone(false);
    setFailed(false);
    setDisplay({ DL1: '', DL2: '' });

    fetchStatus();
    const interval = setInterval(() => {
      if (!uiLocked.current) fetchStatus();
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, uuid, fetchStatus]);

  const handleClose = () => {
    setDone(false);
    setFailed(false);
    setDisplay({ DL1: '', DL2: '' });
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={handleClose} elId="linklyRefundStatusModal">
      <div className="modal-body p-5 text-center">
        {amount && (
          <h2 style={{ color: '#dc3545' }}>Refund ${amount}</h2>
        )}

        {!display.DL1 && <h5>Processing...</h5>}

        <div className="mt-3">
          {done && <h4 className="text-success">Refund Complete</h4>}
          {failed && <h4 className="text-danger">Refund Failed</h4>}
          {!done && !failed && <h4>{display.DL1}</h4>}
          {display.DL2 && <span dangerouslySetInnerHTML={{ __html: display.DL2 }} />}
        </div>

        <div className="mt-4 d-flex justify-content-center gap-2">
          {failed && (
            <button className="btn btn-secondary" onClick={handleClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </CommonModal>
  );
};

export default LinklyRefundStatusModal;
